import { FC, ReactNode } from 'react';

import {
	PunchupDonutChart,
	DonutSlice,
	LegendItem,
} from 'features/common/components/Punchup/primitives/charts/PunchupDonutChart';
import { PunchupTile } from 'features/common/components/Punchup/primitives/display/PunchupTile';
import styles from './PunchupTicketInventory.module.css';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface TileSlot {
	title: string;
	value: string;
	descriptions: string[];
	helpButton: ReactNode;
}

export interface DonutSlot {
	centerLabel: string;
	centerLabelColor?: string;
	centerTooltip?: string;
	data: DonutSlice[];
	legendItems?: LegendItem[];
	tooltipFormatter?: (value: number, name: string) => [string, string];
	helpButton: ReactNode;
}

export interface InventoryColumnCardProps {
	tile: TileSlot;
	issuedDonut: DonutSlot;
	fillDonut: DonutSlot;
	newRow?: boolean;
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

const DONUT_SIZE = 150;

export const InventoryColumnCard: FC<InventoryColumnCardProps> = ({ tile, issuedDonut, fillDonut, newRow }) => (
	<div className={`${styles.column}${newRow ? ` ${styles.newRow}` : ''}`}>
		<div className={styles.tileCell}>
			<PunchupTile
				title={tile.title}
				value={tile.value}
				descriptions={tile.descriptions}
				singleLineTitle
				compact
				helpButton={tile.helpButton}
			/>
		</div>
		<div className={styles.donutCell}>
			<PunchupDonutChart
				centerLabel={issuedDonut.centerLabel}
				centerLabelColor={issuedDonut.centerLabelColor}
				centerTooltip={issuedDonut.centerTooltip}
				data={issuedDonut.data}
				size={DONUT_SIZE}
				legendItems={issuedDonut.legendItems}
				helpButton={issuedDonut.helpButton}
			/>
		</div>
		<div className={styles.donutCell}>
			<PunchupDonutChart
				centerLabel={fillDonut.centerLabel}
				centerTooltip={fillDonut.centerTooltip}
				data={fillDonut.data}
				size={DONUT_SIZE}
				legendItems={fillDonut.legendItems}
				tooltipFormatter={fillDonut.tooltipFormatter}
				helpButton={fillDonut.helpButton}
			/>
		</div>
	</div>
);
